import { createSlice, PayloadAction } from "@reduxjs/toolkit"
import type { AdminAddonsStateData } from "@/types/catalog"

export type AdminAddonOptionsState = {
  data: AdminAddonsStateData
  error: string | null
}

export const adminAddonOptionsInitialState: AdminAddonOptionsState = {
  data: {
    addons: [],
    pagination: {
      pageNumber: 1,
      pageSize: 10,
      totalElements: 0,
      totalPages: 0,
    },
  },
  error: null,
}

const slice = createSlice({
  name: "adminAddonOptions",
  initialState: adminAddonOptionsInitialState,
  reducers: {
    setAdminAddonOptionsAction(state, { payload }: PayloadAction<AdminAddonsStateData>) {
      state.data = payload
      state.error = null
    },
    appendAdminAddonOptionsAction(state, { payload }: PayloadAction<AdminAddonsStateData>) {
      const addonMap = new Map(state.data.addons.map((addon) => [addon.id, addon]))

      payload.addons.forEach((addon) => {
        addonMap.set(addon.id, addon)
      })

      state.data = {
        addons: Array.from(addonMap.values()),
        pagination: payload.pagination,
      }
      state.error = null
    },
    setAdminAddonOptionsErrorAction(state, { payload }: PayloadAction<string | null>) {
      state.error = payload
    },
  },
})

export const {
  appendAdminAddonOptionsAction,
  setAdminAddonOptionsAction,
  setAdminAddonOptionsErrorAction,
} = slice.actions
export default slice.reducer
